<template>
  <div class="ml-card ml-card--collapsible">
    <div v-show="!collapsed">
      <slot></slot>
    </div>
    <h3 class="ml-card__title" v-show="collapsed">{{ title }}</h3>

    <div id="collapsible-hide-trigger" class="ml-card__toggle" v-show="!collapsed" @click="toggleCollapsible()">
      <i class="material-icons">expand_less</i>
      <span>Hide</span>
    </div>

    <div id="collapsible-show-trigger" class="ml-card__toggle" v-show="collapsed" @click="toggleCollapsible()">
      <i class="material-icons">expand_more</i>
      <span>Show</span>
    </div>
  </div>
</template>

<script>

export default {
    data () {
      return {
        collapsed: false
      }
    },

    props: {
      title: {
        type: String
      }
    },

    methods: {
      toggleCollapsible () {
        this.collapsed = !this.collapsed
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/_colors";
  
  .ml-card__title {
    background-color: $tingg-primary-red;
  }

  #collapsible-hide-trigger,
  #collapsible-show-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>




// WEBPACK FOOTER //
// src/components/CollapsibleCard.vue